// 'Aggregated' (title-case) is the backend-synthetic accountId; distinct from the AGGREGATED
// constant ('aggregated' lowercase), which is the bankName lookup key used in cashflowLayout.ts.
const AGGREGATED_ACCOUNT_ID = 'Aggregated';

export interface BankingOverviewAccount {
    accountId: string;
    name: string;
    accountNumber?: string | number | null;
}

/** Derive the MultiSelectDropdown options for CFB account filter.
 * Drops the backend-synthetic Aggregated row and formats labels as "Name: accountNumber". */
export function buildCfbAccountOptions(bankingOverview: BankingOverviewAccount[]): { id: string; label: string }[] {
    return bankingOverview
        .filter((a) => a.accountId !== AGGREGATED_ACCOUNT_ID)
        .map((a) => ({
            id: a.accountId,
            label: a.name + (a.accountNumber != null ? ': ' + a.accountNumber : ''),
        }));
}

/** Translate a list of selected account IDs to their coerced account number strings.
 * Numeric accountNumbers (Sequelize DOUBLE raw) are String()-coerced at this boundary.
 * Unknown IDs (no matching overview entry) are dropped. */
export function resolveSelectedAccountNumbers(selectedAccountIds: string[], bankingOverview: BankingOverviewAccount[]): string[] {
    if (selectedAccountIds.length === 0) return [];
    return selectedAccountIds.reduce<string[]>((acc, id) => {
        const account = bankingOverview.find((a) => a.accountId === id);
        const n = account?.accountNumber;
        if (n != null) acc.push(String(n));
        return acc;
    }, []);
}
